import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ResiliencyMap from "@/pages/ResiliencyMap";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ResiliencyMap />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
